import React from 'react';
import {
  Card,
  CardFooter,
  CardSection,
  Gutter,
  Layout,
  LayoutItem,
  Paragraph,
  SmallHeader,
  Visible,
} from '@axiom/ui';
import type { Account, User } from '@axiom/validation';

import RocketShip from '../../public/svg/rocket-ship.svg';
import { StartEngagementButton } from '../StartEngagementButton/StartEngagementButton';

export type EngagementCarouselEndCardProps = {
  account: Account;
  user: User;
  name?: string;
};

export const EngagementCarouselEndCard = ({
  account,
  user,
  name = 'ENGAGEMENT_CAROUSEL_END_CARD',
}: EngagementCarouselEndCardProps) => {
  return (
    <Card name={name} stretched>
      <CardSection>
        <Layout>
          <Visible only="tablet largeScreen">
            <LayoutItem rightGutter="24px">
              <RocketShip width="117px" height="117px" />
            </LayoutItem>
          </Visible>
          <LayoutItem>
            <SmallHeader>Start a new engagement</SmallHeader>
            <Gutter bottom="16px" />
            <Paragraph>
              We will walk you through finding talent that matches your legal
              needs.
            </Paragraph>
          </LayoutItem>
        </Layout>
      </CardSection>
      <CardFooter>
        <StartEngagementButton
          name="END_CARD_START_ENGAGEMENT"
          pattern="secondary"
          user={user}
          variation="filled"
          account={account}
        >
          Start an Engagement
        </StartEngagementButton>
      </CardFooter>
    </Card>
  );
};
